import styled from '@emotion/styled';

export const MainBlock = styled.div`
  margin-bottom: 20px;
`;
